/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const activityLabelSchema = z.enum(['messaged', 'stage_moved', 'applied', 'interview'])

export type ActivityLabelSchema = z.infer<typeof activityLabelSchema>
